// extracted by mini-css-extract-plugin
export default {"statisticsCard":"CardStatistics_statisticsCard__yiir4","nameBody":"CardStatistics_nameBody__0OQGk","description":"CardStatistics_description__FmZo9"};